import { serialize } from "../../../utils";
export default {
  namespaced: true,
  state: {
    path: "aljabr/telegram-api/parents-chats-dev",
  },
  actions: {
    get({ dispatch, state, rootState }, options = {}) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}?${serialize(options)}`,
          method: "GET",
          data: options,
        },
        { root: true }
      );
    },
    create({ dispatch, state, rootState }, options = {}) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/create`,
          method: "POST",
          data: options,
        },
        { root: true }
      );
    },
    reactivate({ dispatch, state, rootState }, options = {}) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/reactivate`,
          method: "POST",
          data: options,
        },
        { root: true }
      );
    },
    sendMessage({ dispatch, state, rootState }, options = {}) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/sendMessage`,
          method: "POST",
          data: options,
        },
        { root: true }
      );
    },
    uploadFile({ dispatch, state, rootState }, options = {}) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/upload-file`,
          method: "VID",
          data: options,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
        { root: true }
      );
    },
    auth({ dispatch, state, rootState }, options = {}) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/auth?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
  },
};
